export const assertNever = (statusCode: number): never => {
  throw Error('Unknown status code: ' + statusCode);
};
